<template>        
    <v-flex xs12 pr-2>     
        <v-layout row align-center>
            <v-text-field                 
                @click:clear="selectCleared"
                @click="showModal"         
                @blur="updateValue()"    
                v-model="timeText"          
                :value="value"
                :label="label" 
                :disabled="disabled"    
                :required="required" 
                :error="error"          
                type="time"                                      
            ></v-text-field>        
        </v-layout>   
        <v-dialog v-model="showPicker" scrollable max-width="300px">                
            <v-card>
                <v-card-title>{{label}}</v-card-title>
                <v-layout column style="bacxground-color:white;">                        
                    <v-time-picker v-model="timeText" format="24hr"></v-time-picker>                                                    
                    <v-btn color="blue darken-1" flat @click="updateTime()">Sluiten</v-btn>
                </v-layout>                                                                                     
            </v-card>
        </v-dialog>   
    </v-flex>
</template>

<script>
    export default {
        components:{            
        },        
        props:['value','label','disabled', 'required','error','type'],
        data() {
            return {
                showPicker:false,
                timeText:"",
            }
        },        
        computed: {
            usedType(){
                // options text or time_picker. default is time_picker
                return this.type ? this.type : "time_picker"
            },
        },
        methods: {        
            updateValue(){
                if(this.usedType == "text"){
                    this.updateTime()
                }
            },            
            updateTime(){
                
                this.showPicker=false
                this.$emit('input',  this.timeText)
            },
            showModal(){
                if(this.usedType == 'time_picker')
                this.showPicker=!this.showPicker                
            },
            selectCleared(){
                this.$emit('input', "")
            }
        },    
        watch: {
            'value': {
                handler:function(newValue){                    
                    this.timeText = newValue;                    
                },
                deep:true
            }
        },
        created(){            
            this.timeText = this.value
        }

    }
</script>

<style scoped>
    .icon-tray{
        width: 50px;
        height: 50px;
        border: 1px solid lightgray;
    }
    .icon-tray:hover{
        background-color:lightgray;
        cursor:pointer;
    }
</style>